import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';

import useStyles from './useStyles';

const MonthlyBudget = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    income,
    incomePercent,
    taxes,
    taxesPercent,
    savings,
    savingsPercent,
    loanPayments,
    loanPaymentsPercents,
    otherExpenses,
    otherExpensesPercent,
  } = props;

  return (
    <Box className={classes.paper}>
      <Typography variant="body1" color="inherit" className={classes.label}>
        {t('components.Quiz.SummaryPage.MonthlyBudget.label')}
      </Typography>
      <Box display="flex" mt={2}>
        <Box width="55%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.MonthlyBudget.income')}
          </Typography>
        </Box>
        <Box width="33%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={income} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
          </Typography>
        </Box>
        <Box width="12%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={incomePercent} displayType="text" thousandSeparator decimalScale={0} suffix="%" />
          </Typography>
        </Box>
      </Box>
      <Box display="flex" mt={0.8}>
        <Box width="55%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.MonthlyBudget.taxes')}
          </Typography>
        </Box>
        <Box width="33%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={taxes} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
          </Typography>
        </Box>
        <Box width="12%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={taxesPercent} displayType="text" thousandSeparator decimalScale={0} suffix="%" />
          </Typography>
        </Box>
      </Box>
      <Box display="flex" mt={0.8}>
        <Box width="55%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.MonthlyBudget.savings')}
          </Typography>
        </Box>
        <Box width="33%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={savings} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
          </Typography>
        </Box>
        <Box width="12%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={savingsPercent} displayType="text" thousandSeparator decimalScale={0} suffix="%" />
          </Typography>
        </Box>
      </Box>
      <Box display="flex" mt={0.8}>
        <Box width="55%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.MonthlyBudget.loanPayments')}
          </Typography>
        </Box>
        <Box width="33%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={loanPayments} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
          </Typography>
        </Box>
        <Box width="12%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat
              value={loanPaymentsPercents}
              displayType="text"
              thousandSeparator
              decimalScale={0}
              suffix="%"
            />
          </Typography>
        </Box>
      </Box>
      <Box display="flex" mt={0.8}>
        <Box width="55%">
          <Typography color="secondary" variant="body2">
            {t('components.Quiz.SummaryPage.MonthlyBudget.otherExpenses')}
          </Typography>
        </Box>
        <Box width="33%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat value={otherExpenses} displayType="text" thousandSeparator decimalScale={0} prefix="$" />
          </Typography>
        </Box>
        <Box width="12%">
          <Typography color="secondary" variant="body1" className={classes.bold}>
            <NumberFormat
              value={otherExpensesPercent}
              displayType="text"
              thousandSeparator
              decimalScale={0}
              suffix="%"
            />
          </Typography>
        </Box>
      </Box>
      <Box className={classes.divider} />
      <Typography color="secondary" variant="body2" className={classes.bold}>
        {t('components.Quiz.SummaryPage.MonthlyBudget.otherExpensesExplainHeader')}
      </Typography>
      <Typography color="secondary" variant="body2">
        {t('components.Quiz.SummaryPage.MonthlyBudget.otherExpensesExplainContent')}
      </Typography>
    </Box>
  );
};

MonthlyBudget.propTypes = {
  income: PropTypes.number.isRequired,
  incomePercent: PropTypes.number.isRequired,
  taxes: PropTypes.number.isRequired,
  taxesPercent: PropTypes.number.isRequired,
  savings: PropTypes.number.isRequired,
  savingsPercent: PropTypes.number.isRequired,
  loanPayments: PropTypes.number.isRequired,
  loanPaymentsPercents: PropTypes.number.isRequired,
  otherExpenses: PropTypes.number.isRequired,
  otherExpensesPercent: PropTypes.number.isRequired,
};

export default MonthlyBudget;



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/SummaryPage/components/MonthlyBudget/MonthlyBudget.js